import { defineAsyncComponent } from 'vue'
export default {
  blank: defineAsyncComponent(() => import("/vercel/path0/layouts/blank.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/vercel/path0/layouts/default.vue").then(m => m.default || m)),
  simple: defineAsyncComponent(() => import("/vercel/path0/layouts/simple.vue").then(m => m.default || m))
}